import { render } from "./SpeechAssistant.vue?vue&type=template&id=6cfa9178&scoped=true&ts=true"
import script from "./SpeechAssistant.vue?vue&type=script&lang=ts"
export * from "./SpeechAssistant.vue?vue&type=script&lang=ts"

import "./SpeechAssistant.vue?vue&type=style&index=0&id=6cfa9178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfa9178"]])

export default __exports__